/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { deploymentsLatest } from "../funcs/deploymentsLatest.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GetLatestDeploymentResult } from "../models/components/getlatestdeploymentresult.js";
import {
  GetLatestDeploymentRequest,
  GetLatestDeploymentSecurity,
} from "../models/operations/getlatestdeployment.js";
import { unwrapAsync } from "../types/fp.js";
export type LatestDeploymentQueryData = GetLatestDeploymentResult;

export function prefetchLatestDeployment(
  queryClient: QueryClient,
  client$: GramCore,
  request?: GetLatestDeploymentRequest | undefined,
  security?: GetLatestDeploymentSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildLatestDeploymentQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildLatestDeploymentQuery(
  client$: GramCore,
  request?: GetLatestDeploymentRequest | undefined,
  security?: GetLatestDeploymentSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<LatestDeploymentQueryData>;
} {
  return {
    queryKey: queryKeyLatestDeployment({
      gramKey: request?.gramKey,
      gramSession: request?.gramSession,
      gramProject: request?.gramProject,
    }),
    queryFn: async function latestDeploymentQueryFn(
      ctx,
    ): Promise<LatestDeploymentQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(deploymentsLatest(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyLatestDeployment(
  parameters: {
    gramKey?: string | undefined;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "deployments", "latest", parameters];
}
